/* eslint-disable import/no-cycle */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useContext, useEffect, useState } from "react";

import longBanner from "Images/checkout/long_banner.svg";
import nameLogo from "Images/checkout/name_logo.svg";
import logoSquare from "Images/checkout/logo_square.svg";
import { GainfulButton, CheckoutProgressbar } from "CheckoutComponents";
import { useHistory, useLocation } from "react-router-dom";
import { CheckoutContext } from "Root/checkout/CheckoutRoutes";
import styles from "./styles.module.css";
import BlackFridayBanner from "Root/profile/components/common/BlackFridayBanner";
import sendPostHogDataHelper from "Root/hooks/sendPostHogDataHelper";
import { useScreenWidth } from "Root/profile/components/SubscriptionPageV2/hooks";

function  Navbar(props) {
  const { discountBanner, checkoutPages } = useContext(CheckoutContext);
  // const total_items = props.cart ? Object.values(props.cart).reduce((prev, current) => prev + current, 0) : 0;
  const [active, setActive] = useState(null);
  const history = useHistory();

  const isMobile = useScreenWidth() < 968;

  const cancel = () => {
    history.push("");
    window.location.reload();
  };

  const goNext = () => {
    const next = checkoutPages[active + 1];
    if (
      next === "/checkout/personalizations/" &&
      props.cart?.protein === 0 &&
      props.cart?.preworkout === 0 &&
      props.cart?.hydration === 0
    ) {
      history.push(checkoutPages[active + 2]);
    } else {
      history.push(next);
    }
  };

  const location = useLocation();

  useEffect(() => {
    if (active !== null && active >= 0) {
      const event = "checkout pageview";
      const properties = { page_num: active + 1, page_name: location.pathname };
      sendPostHogDataHelper(event, properties);
    }
  }, [active]);

  useEffect(() => {
    setActive(checkoutPages.indexOf(location.pathname));
  }, [checkoutPages, location]);

  const midButtonText =
    props.cart?.protein > 0 || props.cart?.preworkout > 0 || props.cart?.hydration > 0
      ? "Select Your Flavors"
      : "Proceed To Checkout";
  // : "Review Order";

  const buttonText = props.view !== "simplified" ? midButtonText : "Proceed To Checkout";

  return (
    <>
      <div className={styles.checkout_header_wrapper}>
        {!discountBanner && props.bannerData.copy && (
          <BlackFridayBanner className={styles.black_friday} data={props.bannerData} />
        )}
        <div className={`${props.unfixed ? styles.abstop : styles.fixedtop}`}>
          <div className={styles.topheader}>
            <div role="button" tabIndex={0} className={`${styles.navflexelem} ${styles.navleft}`} onClick={cancel}>
              <img alt="banner" className={styles.long_banner} src={longBanner} />
              <img alt="logo" src={nameLogo} />
            </div>

            <div role="button" tabIndex={-1} className={styles.smallscreennav} onClick={cancel}>
              <img alt="square logo" src={logoSquare} />
            </div>

            {active >= 0 && (
              <CheckoutProgressbar
                active={active}
                pages={checkoutPages}
                nextDisabled={props.nextDisabled}
                onGoNext={props.onGoNext}
              />
            )}
            {props.view === "howtolp" && (
              <>
                <div className={`${styles.navflexelem} ${styles.left}`} style={{ display: "flex" }} />
                <div
                  className={`${styles.navflexelem} ${styles.navright}`}
                  style={{ display: "flex", marginRight: "0px" }}
                >
                  <GainfulButton style={{ width: "148px" }} text="Checkout" onClick={goNext} />
                </div>
              </>
            )}

            {!props.isBottomHidden && props.isOneButton ? (
              <></>
            ) : (
              !props.isBottomHidden && (
                <div
                  className={`${styles.navflexelem} ${styles.navright} ${
                    props.view === "simplified" ? styles.nav_hidden : ""
                  }`}
                />
              )
            )}
          </div>
        </div>
      </div>

      {!props.isBottomHidden && props.isOneButton ? (
        <div
          className={`${props.view === "simple" ? styles.nofixed : styles.fixedbottom}  
            ${props.view !== "simplified" ? styles.animatedbottom : ""}
            ${styles.delayedbottom}`}
        >
          {discountBanner && props.active === 1 && <div className={styles.discountBanner}>{discountBanner}</div>}
          <div className={styles.bottomnavcontainer}>
            <GainfulButton style={{ width: "148px" }} size="large" text="Customize Your System" onClick={goNext} />
          </div>
        </div>
      ) : (
        !props.isBottomHidden && (
          <div
            className={`${props.view === "simple" ? styles.nofixed : styles.fixedbottom} ${
              props.view !== "simplified" ? styles.animatedbottom : ""
            }`}
          >
            <div className={styles.bottomnavcontainer}>
              {props.view === "simplified" ? (
                <div
                  role="button"
                  tabIndex={-1}
                  className={`${styles.subdesc} ${styles.cancel_link}`}
                  onClick={props.cancel}
                >
                  <span>Back</span>
                </div>
              ) : (
                <></>
              )}
              <GainfulButton style={{ width: "141px" }} text={buttonText} onClick={goNext} />
            </div>
          </div>
        )
      )}
    </>
  );
}

export default Navbar;
